module.exports = __webpack_public_path__ + "static/img/200007.9ee4e4d8.png";